module.exports = __webpack_public_path__ + "media/images/bg/headers/registration-c17aeb048650ea0f6e65e311bcc6e818.jpg";